module.exports = __webpack_public_path__ + "img/close.aa03c809.svg";